import { createReducer, getUpdater } from '@advanza/advanza_generic'
import { PROMOS_CHANGE_FILTER, PROMOS_RECEIVE_LIST, PROMOS_REQUEST } from '../actions/promos'
import {
    changeEntity,
    changeFilter,
    invalidateFilters,
    receiveList,
    selectItems,
} from './sharedReducerHandlers'

const update = getUpdater()

const handlers = {
    [PROMOS_RECEIVE_LIST]: receiveList,
    [PROMOS_REQUEST]: (state, action) =>
        update(state, {
            isFetching: { $set: action.filterId || true },
        }),
    [PROMOS_CHANGE_FILTER]: changeFilter,
    CHANGE_ENTITY_PROMOS: changeEntity,
    INVALIDATE_PROMOS: invalidateFilters,
    PROMOS_SELECT_ITEMS: selectItems,
}

const initialState = {
    isFetching: false,
    didInvalidate: false,
    entities: {},
    result: {},
    counts: {},
    filters: {},
}

export default createReducer(initialState, handlers)
